<template>
  <div class="container">
    <el-form :model="inputForm" ref="inputForm" @submit.native.prevent class="el-form search-form"
      :class="{rightBorder: searchTabActive!=='Blending'}">
      <el-row>
        <el-col :span="12" style="padding-right: 40px;">
          <el-form-item prop="userInputModelName">
            <el-autocomplete class="inline-input userInputPJName" v-model="inputForm.userInputModelName"
              :fetch-suggestions="querySearch" :placeholder="$t('T_MODEL_SEARCH_TIPS')" :trigger-on-focus="false"
              @select="onModelSearch" clearable @keyup.enter.native="onModelSearch" style="width: 100%">
              <el-button slot="append" :class="{searchIcon:!isPress, searchIconPress: isPress}"
                @mousedown.native="isPress = true" @click="onModelSearch" @mouseup.native="isPress = false"></el-button>
            </el-autocomplete>
          </el-form-item>
        </el-col>
        <el-form-item :label="$t('T_SEARCH_RESULT') + ':'" class="search-result-item">
          <span>{{ blendingMatchingModelData.length }}</span>
          <span v-if="blendingMatchingModelData.length === 1 || blendingMatchingModelData.length === 0">{{$t('T_RESULT')}}</span>
          <span v-else>{{$t('T_RESULTS')}}</span>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 260px;" v-model="inputForm.selectedModel" @change="onModelChange">
            <el-option v-for="item in matchingModelDataSort" :key="item.value" :value="item.name" :label="item.name" />
          </el-select>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'searchProjector',
  data () {
    return {
      // 平面
      // flatPj: ['Luxembourg', 'Nepal', 'Nepal10', 'Nepal10-UG 9Klm', 'Nepal10-UG', 'Mongolia', 'Poland', 'Iceland', 'Lemonade',
      //   'Kuwait-DS', 'Latvia', 'Iceland-UG', 'Bolivia-UST', 'Mongolia2'],
      flatPj: [],
      // 曲面
      // curvePj: ['Luxembourg', 'Nepal', 'Nepal10', 'Nepal10-UG 9Klm', 'Nepal10-UG', 'Mongolia', 'Poland', 'Iceland', 'Mongolia2'],
      curvePj: [],
      blendModelDataArr: [], // 支持的全部机种
      blendingMatchingModelData: [],
      blendingSelectedModelData: '',
      inputForm: {
        userInputModelName: '',
        selectedModel: ''
      },
      userInput: '',
      isPress: false,
      selectOptions: [],
      selectedModelIndex: 0
    }
  },
  computed: {
    ...mapState([
      'blendingParam',
      'matchingModelData',
      'selectedModelData',
      'searchTabActive',
      'isSimple',
      'position',
      'fromBlending'
    ]),

    matchingModelDataSort () {
      return this.$commonJs.dataSort(this.blendingMatchingModelData, 'name')
    },

    differentModelSeries () {
      return this.flatPj.concat(this.curvePj).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v)
      })
    }
  },
  watch: {
    searchTabActive (val, oldVal) {
      if (val === 'Blending' && oldVal === 'Search' && this.fromBlending) {
        this.blendingMatchingModelData = this.matchingModelData
        this.MATCHINGMODELDATA(this.blendingMatchingModelData)
        this.SELECTEDMODELDATA(this.selectedModelData)
        return
      }
      if (val === 'Blending') {
        let lensData = this.findMatchingLensAndSelectedLensData(this.blendingMatchingModelData)
        this.setSpecificInfo(lensData.selectedLensInfo)
        this.MATCHINGMODELDATA(this.blendingMatchingModelData)
        this.SELECTEDMODELDATA(this.blendingSelectedModelData)
        this.MATCHINGLENSID(lensData.matchingLensID)
        this.SELECTEDLENSDATA(lensData.selectedLensInfo)
      }
    },

    selectedModelData (val, oldVal) {
      if (this.searchTabActive === 'Blending') {
        this.inputForm.selectedModel = val.name
      }
    },
    'blendingParam.shapeShow': {
      handler (val, oldVal) {
        // 凹面凸面切换时 不改变投影仪
        if (val !== '2' && oldVal !== '2') {
          return
        }
        this.init(val, oldVal)
        if ((val === '2' && oldVal !== '2') || (val !== '2' && oldVal === '2' && this.curvePj.indexOf(this.selectedModelData.name) !== -1)) {
          return
        }
        let lensData = this.findMatchingLensAndSelectedLensData(this.blendingMatchingModelData)
        this.setSpecificInfo(lensData.selectedLensInfo)
        this.MATCHINGMODELDATA(this.blendingMatchingModelData)
        this.SELECTEDMODELDATA(this.blendingSelectedModelData)
        this.MATCHINGLENSID(lensData.matchingLensID)
        this.SELECTEDLENSDATA(lensData.selectedLensInfo)
      }
    }
  },
  methods: {
    ...mapMutations([
      'F_S2D',
      'F_D2S',
      'F_VOFFSET',
      'VLENSSHIFT',
      'HLENSSHIFT',
      'VHLENSSHIFT',
      'ASPECTRATIO',
      'MATCHINGMODELDATA', 'SELECTEDMODELDATA', 'MATCHINGLENSID', 'SELECTEDLENSDATA', 'SET_TEMVLENSSHIFT',
      'SET_FROMBLENDING'
    ]),

    querySearch (queryString, cb) {
      var results = queryString ? this.blendingMatchingModelData.filter(this.createFilter(queryString)) : this.blendingMatchingModelData
      // 调用 callback 返回建议列表的数据
      results.sort((obj1, obj2) => {
        return obj1.name.localeCompare(obj2.name)
      })
      cb(results)
    },

    createFilter (queryString) {
      return (dataOptions) => {
        dataOptions.value = dataOptions.name
        return (dataOptions.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1)
      }
    },
    setSelectedPJModel (value) {
      this.selectedModelIndex = 0
      this.MATCHINGMODELDATA([value])
      this.SELECTEDMODELDATA(value)
      this.findMatchingLensAndSelectedLensData([value])
    },
    // 匹配投影仪
    onModelSearch (event) {
      this.findMatchingModel()
      this.userInput = this.inputForm.userInputModelName
    },
    findMatchingModel () {
      let matchModelArr = []
      let userInputModelName = this.inputForm.userInputModelName.toLowerCase()
      let isSame = false
      this.selectedModelIndex = 0
      this.blendModelDataArr.filter(item => {
        let pjName = item.name.toLowerCase()
        if (pjName.indexOf(userInputModelName) !== -1) {
          matchModelArr.push(item)
        }
        if (pjName === userInputModelName) {
          isSame = true
        }
      })
      matchModelArr = this.$commonJs.dataSort(matchModelArr, 'name')
      if (isSame) {
        this.selectedModelIndex = matchModelArr.findIndex((item) => item.name.toLowerCase() === userInputModelName)
      }
      if (matchModelArr.length > 0) {
        this.setModeldata(matchModelArr)
        this.findMatchingLensAndSelectedLensData(matchModelArr)
      } else {
        if (document.getElementsByClassName('el-message').length === 0) {
          this.$message.warning({
            message: this.$t('T_NO_RESULT'),
            duration: 3000
          })
        }
      }
    },
    setModeldata (value) {
      this.blendingMatchingModelData = value
      this.blendingSelectedModelData = value[this.selectedModelIndex]
      this.MATCHINGMODELDATA(this.blendingMatchingModelData)
      this.SELECTEDMODELDATA(this.blendingSelectedModelData)
    },
    setLensData (idArr, data) {
      this.MATCHINGLENSID(idArr)
      this.SELECTEDLENSDATA(data)
    },
    findMatchingLensAndSelectedLensData (modelArr) {
      let selectedModelData = modelArr[this.selectedModelIndex]
      let lensInfo = this.$commonJs.findLensInfo(selectedModelData)
      this.setLensData(lensInfo.matchingLensID, lensInfo.selectedLensInfo)
      return lensInfo
    },
    setSpecificInfo (data) {
      let defaultRatio = data.lcd.aspectRatio
      let defaultDistInfo = data.lcd.distInfo.find(
        item => item.ratio === defaultRatio
      )
      this.F_S2D(defaultDistInfo.size2dist)
      this.F_D2S(defaultDistInfo.dist2size)
      this.F_VOFFSET(defaultDistInfo.screenSizeToVOffset)

      this.VLENSSHIFT(data.lcd.lensShiftRange.v)
      this.SET_TEMVLENSSHIFT(data.lcd.lensShiftRange.v)
      this.HLENSSHIFT(data.lcd.lensShiftRange.h)
      this.VHLENSSHIFT(data.lcd.lensShiftRange.hv)
      this.ASPECTRATIO(data.lcd.aspectRatio)
    },

    // 投影仪切换
    onModelChange (value) {
      this.setSelectedModelData(value)
      this.findMatchingLensAndSelectedLensData(this.blendingMatchingModelData)
    },

    setSelectedModelData (value) {
      this.blendingSelectedModelData = this.blendingMatchingModelData.find(
        item => item.name === value
      )
      this.selectedModelIndex = this.blendingMatchingModelData.findIndex(
        item => item.name === value
      )
      this.SELECTEDMODELDATA(this.blendingSelectedModelData)
    },
    init (val, oldVal) {
      let pjArr
      let modelDataArr = []
      this.ProjectorSpec.filter((item) => {
        if (item.edgeBlendFlat) {
          this.flatPj.push(item.name)
        }
      })
      this.ProjectorSpec.filter((item) => {
        if (item.edgeBlendCurve) {
          this.curvePj.push(item.name)
        }
      })
      if (this.blendingParam.shapeShow === '2') {
        pjArr = this.flatPj
      } else {
        pjArr = this.curvePj
      }
      this.ProjectorSpec.map((item) => {
        if (pjArr.indexOf(item.name) !== -1) {
          modelDataArr.push(item)
        }
      })
      this.blendModelDataArr = JSON.parse(JSON.stringify(modelDataArr))
      this.blendingMatchingModelData = JSON.parse(JSON.stringify(modelDataArr))
      // 曲面切到平面式 不改变投影仪
      // 平面切到曲面时 投影仪支持曲面投影时 不改变投影仪
      if ((val === '2' && oldVal !== '2') || (val !== '2' && oldVal === '2' && this.curvePj.indexOf(this.selectedModelData.name) !== -1)) {
        // do nothing
      } else {
        this.blendingSelectedModelData = this.blendingMatchingModelData[0]
        this.inputForm.selectedModel = this.blendingSelectedModelData.name
      }
      this.selectedModelIndex = this.blendingMatchingModelData.findIndex(
        item => item.name === this.blendingSelectedModelData.name
      )
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style scoped>
.searchIcon {
  background: url('~@/assets/parts/icon/TDC_search.png') no-repeat center;
}

.searchIconPress {
  background: url('~@/assets/parts/icon/TDC_search.png') no-repeat center;
}
.rightBorder{
  border-right: 2px solid #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/view/searchTabs/searchProjector.vue